import { BrandingWrapper } from '@insify/funnel-components';

import { useCoBranding } from '../../hooks/useCoBranding';

export const CoBrandingWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasCoBranding, branding } = useCoBranding();
  return (
    <BrandingWrapper enabled={hasCoBranding} branding={branding}>
      {children}
    </BrandingWrapper>
  );
};
